import {EventEmitter, Injectable} from '@angular/core';
import {BASE_URL} from '../../shared/constants';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Offer} from '../../models/Offer';
import {filter, first} from 'rxjs/operators';
import {NavigationStart, Router} from '@angular/router';
import {AreaService} from '../area/area.service';
import {TranslatableString} from '../../models/TranslatableString';

@Injectable({
  providedIn: 'root'
})
export class OffersService {

  SELECTED_OFFER_URL = '/property/single/';
  SELECTED_OFFER_PICTURES_URL = '/property/singlepics/';
  SELECTED_OFFER_FEATURES_URL = '/property/singlefeat/';
  PROPERTY_SUBTYPE_URL = '/propertysubtype/propertysubtype';
  OFFERS_URL = '/property/active';
  OFFERS_MAP_URL = '/property/active-unsold';

  selectedCurrency: string;

  mapProperties: Array<Offer>;
  mapMarkers: Array<google.maps.Marker>;
  googleMapsReady: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient, private router: Router, private areaService: AreaService) {
    this.changeSelectedCurrencyTo('EUR');
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      this.changeSelectedCurrencyTo('EUR');
    });
  }

  getOffers(): Observable<any> {
    return this.http.get(BASE_URL + this.OFFERS_URL);
  }

  getSelectedOffer(id: number) {
    return this.http.get<any>(BASE_URL + this.SELECTED_OFFER_URL, {params: {property_id: id.toString()}});
  }

  getSelectedOfferPictures(id: number) {
    return this.http.get<any>(BASE_URL + this.SELECTED_OFFER_PICTURES_URL, {params: {property_id: id.toString()}});
  }

  getSelectedOfferPropertySpecifications(id: number) {
    return this.http.get<any>(BASE_URL + this.SELECTED_OFFER_FEATURES_URL, {params: {property_id: id.toString()}});
  }

  getOfferSubtypes(): Observable<any> {
    return this.http.get(BASE_URL + this.PROPERTY_SUBTYPE_URL);
  }

  getOffersForMap() {
    this.http.get<Array<Offer>>(BASE_URL + this.OFFERS_MAP_URL).subscribe((res: Array<Offer>) => {
      this.mapProperties = [];
      this.mapMarkers = [];
      res.forEach((property: any) => {
        if (property.property_latitude && property.property_longtitude) {
          const prop = new Offer(property);
          const latlng = new google.maps.LatLng(prop.lat, prop.lng);
          const imageURL = prop.isRentable ? 'pin-maps-rent.png' : 'pin-maps-sale.png';
          const marker = new google.maps.Marker({
            position: latlng,
            icon: 'assets/images/' + imageURL
          });
          this.mapMarkers.push(marker);
          this.mapProperties.push(prop);
        }
      });
      this.googleMapsReady.emit();
    });
  }

  getConvertedPrice(price: string): string {
    let defaultToCurrentCurrencyMultiplier = 0;
    if (this.selectedCurrency === 'BGN') {
      defaultToCurrentCurrencyMultiplier = 1.95583;
    } else if (this.selectedCurrency === 'EUR') {
      defaultToCurrentCurrencyMultiplier = 1;
    }

    let convertedPrice = (
      this.getPriceNumberValue(price) * defaultToCurrentCurrencyMultiplier
    ).toFixed(0);
    const parts = convertedPrice.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    convertedPrice = parts.join('.');
    return convertedPrice;
  }

  getPriceNumberValue(price: string): number {
    return Number(price.replace(' ', ''));
  }

  changeSelectedCurrencyTo(newCurrency: string) {
    if (newCurrency === 'BGN') {
      this.selectedCurrency = newCurrency;
    } else if (newCurrency === 'EUR') {
      this.selectedCurrency = newCurrency;
    }
  }
}
